<template>
    <template v-if="component.category === 'number'">
        <div style="height: calc(100% - 49px);text-align: center;" ref="value"
             :style="{lineHeight: component.h * 150 - 91 + 'px'}">
            <b style="font-size: 2.5em;line-height: .5em" v-if="value !== null">
                {{
                    metric.category === 'duration' ? formatDuration(value) : metric.metric_type === 'percent' && metric.category.indexOf('retain') < 0 ? (value * 100).toFixed(2) : formatInt(value)
                }}<span
                v-if="value && metric.metric_type === 'percent'">%</span>
            </b>
            <b class="color-info" style="font-size: 2.5em" v-else> 无数据</b>
        </div>
        <div style="height: 32px">
            <p style="margin: 0; font-size: 12px;" class="color-info">
                <span style="vertical-align: middle;line-height: 32px">日环比</span>
                <b style="font-size: 18px;vertical-align: middle;line-height: 32px;margin-left: 10px">
                    <span class="color-success" v-if="dod > 0"><Top/> {{ dod.toFixed(2) }}%</span>
                    <span class="color-error" v-else-if="dod < 0"><Bottom/> {{ dod.toFixed(2) }}%</span>
                    <span class="color-info" v-else><Minus/> </span>
                </b>
                <b style="float: right;vertical-align: middle;font-size: 18px;line-height: 32px">
                    <span class="color-success" v-if="wow > 0"><Top/> {{ wow.toFixed(2) }}%</span>
                    <span class="color-error" v-else-if="wow < 0"><Bottom/> {{ wow.toFixed(2) }}%</span>
                    <span class="color-info" v-else><Minus/> </span>
                </b>
                <span
                    style="float: right;vertical-align: middle;line-height: 32px;margin-right: 10px">周同比</span>
            </p>
        </div>
    </template>
    <template v-else>
        <div style="height: 48px" v-if="!component.groupings.length">
            <p style="margin: 0; font-size: 12px" class="color-info">
                <span style="vertical-align: middle;line-height: 48px">{{ value_date }}</span>
                <b style="font-size: 32px;line-height: 48px;margin-left: 10px;color: var(--el-text-color-primary)"
                   v-if="value !== null">{{
                        metric.category === 'duration' ? formatDuration(value) : metric.metric_type === 'percent' && metric.category.indexOf('retain') < 0 ? (value * 100).toFixed(2) : formatInt(value)
                    }}
                    <span v-if="value && metric.metric_type === 'percent'">%</span>
                </b>
                <b class="color-info" style="font-size: 2.5em" v-else> 无数据</b>
                <span style="vertical-align: middle;line-height: 48px;margin-left: 20px">日环比</span>
                <b style="font-size: 18px;vertical-align: middle;line-height: 48px;margin-left: 10px">
                    <span class="color-success" v-if="dod > 0">
                        <el-icon><Top/></el-icon> {{ dod.toFixed(2) }}%</span>
                    <span class="color-error" v-else-if="dod < 0">
                        <el-icon><Bottom/></el-icon> {{ dod.toFixed(2) }}%</span>
                    <span class="color-info" v-else><el-icon><Minus/></el-icon> </span>
                </b>
                <span style="vertical-align: middle;line-height: 48px;margin-left: 20px">周同比</span>
                <b style="vertical-align: middle;font-size: 18px;line-height: 48px;margin-left: 10px">
                    <span class="color-success" v-if="wow > 0">
                        <el-icon><Top/></el-icon> {{ wow.toFixed(2) }}%</span>
                    <span class="color-error" v-else-if="wow < 0">
                        <el-icon><Bottom/></el-icon> {{ wow.toFixed(2) }}%</span>
                    <span class="color-info" v-else><el-icon><Minus/></el-icon> </span>
                </b>
            </p>
        </div>
        <div class="chart-panel" :style="{height: `calc(100% - ${!component.groupings.length ? '65px': '17px'})`}">
            <div class="chart-main" ref="chart"></div>
            <div class="value-grid" v-if="showValues && valueGrid.rows.length"
                 :style="{gridTemplateColumns: valueGrid.columns}">
                <template v-for="row in valueGrid.rows" :key="row.name">
                    <div class="value-grid-name" :title="row.name">{{ row.name }}</div>
                    <div class="value-grid-cell" v-for="cell in row.values" :key="row.name + '-' + cell.date"
                         :class="{'value-grid-outlier': cell.outlier}"
                         :title="cell.date + ' ' + row.name + ': ' + cell.text">
                        {{ cell.outlier ? '异常 ' : '' }}{{ cell.text }}
                    </div>
                    <div class="value-grid-right"></div>
                </template>
            </div>
        </div>
    </template>
</template>

<script>
import {formatInt, formatDuration} from "../../../libs/utils";

export default {
    name: "ComponentChart",
    props: {
        component: Object,
        metric: Object,
        value: Number,
        value_date: String,
        dod: Number,
        wow: Number,
        showValues: Boolean,
    },
    data() {
        return {
            chart: null,
            valueGrid: {
                columns: '50px 30px',
                rows: [],
            },
            hoverSeries: [],
            hoverDates: [],
        }
    },
    methods: {
        formatDuration(duration) {
            return formatDuration(duration)
        },
        formatInt(value) {
            return formatInt(value);
        },
        resize() {
            if (this.chart) {
                this.chart.resize();
            }
        },
        clear() {
            if (this.chart) {
                this.chart.clear();
            }
        },
        getChart() {
            if (!this.chart && this.$refs.chart) {
                this.chart = echarts.init(this.$refs.chart, this.$root.dark ? 'dark' : '');
            }
            return this.chart;
        },
        resetChart() {
            if (this.chart) {
                this.chart.dispose();
                this.chart = null;
            }
            return this.getChart();
        },
        /** 汇总所有序列的 y 值范围（含趋势线） */
        collectYRange(series, outlierRange) {
            let ymin = Infinity;
            let ymax = -Infinity;
            series.forEach(s => {
                if (!s.data || !s.data.length) return;
                s.data.forEach(pt => {
                    if (pt && typeof pt === 'object' && pt.outlier) return;
                    const y = this.getPointRawValue(pt);
                    if (this.isOutlierValue(y, outlierRange)) return;
                    if (y != null && isFinite(y)) {
                        ymin = Math.min(ymin, y);
                        ymax = Math.max(ymax, y);
                    }
                });
            });
            return {ymin, ymax};
        },
        getPointDate(point) {
            if (Array.isArray(point)) {
                return point[0];
            }
            if (point && typeof point === 'object') {
                const value = point.value;
                return Array.isArray(value) ? value[0] : null;
            }
            return null;
        },
        getPointRawValue(point) {
            if (Array.isArray(point)) {
                return point[1];
            }
            if (point && typeof point === 'object') {
                if (point.rawValue !== undefined) {
                    return point.rawValue;
                }
                const value = point.value;
                return Array.isArray(value) ? value[1] : value;
            }
            return point;
        },
        quantile(values, q) {
            if (!values.length) {
                return null;
            }
            const pos = (values.length - 1) * q;
            const base = Math.floor(pos);
            const rest = pos - base;
            if (values[base + 1] !== undefined) {
                return values[base] + rest * (values[base + 1] - values[base]);
            }
            return values[base];
        },
        detectOutlierRange(series) {
            const values = [];
            series.filter(s => s.name !== '趋势线').forEach(s => {
                (s.data || []).forEach(pt => {
                    const y = Number(this.getPointRawValue(pt));
                    if (isFinite(y)) {
                        values.push(y);
                    }
                });
            });
            if (values.length < 4) {
                return null;
            }
            values.sort((a, b) => a - b);
            const q1 = this.quantile(values, 0.25);
            const q3 = this.quantile(values, 0.75);
            const iqr = q3 - q1;
            if (!isFinite(iqr) || iqr <= 0) {
                const median = this.quantile(values, 0.5);
                const max = values[values.length - 1];
                const min = values[0];
                const mag = Math.max(Math.abs(median), 1e-9);
                if (max > median + mag * 20) {
                    return {lower: min, upper: median + mag * 3};
                }
                if (min < median - mag * 20) {
                    return {lower: median - mag * 3, upper: max};
                }
                return null;
            }
            return {
                lower: q1 - 3 * iqr,
                upper: q3 + 3 * iqr,
            };
        },
        isOutlierValue(value, range) {
            if (!range) {
                return false;
            }
            const y = Number(value);
            return isFinite(y) && (y < range.lower || y > range.upper);
        },
        /**
         * 根据数据 min/max 计算 Y 轴上下界：按跨度加约 12% 边距，避免小数值区间被 Math.ceil 拉到 0~1。
         * 若 min===max，则在单点附近展开一小段区间。
         */
        computeYAxisBounds(dataMin, dataMax) {
            let min = dataMin;
            let max = dataMax;
            if (!isFinite(min) || !isFinite(max) || min > max) {
                return {min: 0, max: 1};
            }
            let span = max - min;
            if (span <= 0 || !isFinite(span)) {
                const mag = Math.max(Math.abs(min), Math.abs(max), 1e-12);
                span = mag > 0 ? mag * 0.12 : 1e-6;
                min -= span / 2;
                max += span / 2;
            } else {
                const pad = span * 0.12;
                min -= pad;
                max += pad;
            }
            if (dataMin >= 0 && min < 0) {
                min = 0;
            }
            return {min, max};
        },
        /** 根据当前 Y 轴跨度决定小数位数（小范围多展示几位） */
        decimalsForSpan(span) {
            if (!span || !isFinite(span) || span <= 0) {
                return 4;
            }
            const d = Math.ceil(-Math.log10(span)) + 2;
            return Math.min(6, Math.max(2, d));
        },
        formatYAxisNumber(val) {
            const v = Number(val);
            if (!isFinite(v)) {
                return val;
            }
            if (this.metric.category === 'duration') {
                return formatDuration(v);
            }
            const span = this._yAxisSpan;
            if (span > 0 && span < 1000) {
                const dec = this.decimalsForSpan(span);
                return Number(v.toFixed(dec));
            }
            if (v >= 10 ** 9) {
                return (v / 10 ** 9).toFixed(1) + 'b';
            }
            if (v >= 10 ** 6) {
                return (v / 10 ** 6).toFixed(1) + 'm';
            }
            if (v >= 10 ** 3) {
                return (v / 10 ** 3).toFixed(1) + 'k';
            }
            return formatInt(v);
        },
        formatTooltipValue(value) {
            const y = Number(value);
            if (!isFinite(y)) {
                return null;
            }
            if (this.metric.category === 'duration') {
                return formatDuration(y);
            }
            return this._yAxisSpan > 0 && this._yAxisSpan < 1000
                ? y.toFixed(this.decimalsForSpan(this._yAxisSpan))
                : formatInt(y);
        },
        buildSeries(series) {
            return series.filter(s => s && s.type).map(s => ({
                ...s,
                showSymbol: s.name !== '趋势线',
                symbolSize: s.symbolSize || (s.name !== '趋势线' ? 6 : 0),
            }));
        },
        buildTrendLine(series, outlierRange) {
            if (series.length !== 1) {
                return;
            }
            const baseData = series[0].data.filter(d => !this.isOutlierValue(this.getPointRawValue(d), outlierRange));
            if (baseData.length < 2) {
                return;
            }
            const scatter = baseData.map((d, i) => [i + 1, this.getPointRawValue(d)]);
            const regression = ecStat.regression('polynomial', scatter, 1);
            const fit = [];
            regression.points.forEach((p, i) => {
                fit.push([this.getPointDate(baseData[i]), p[1]]);
            });
            series.push({
                name: '趋势线',
                type: 'line',
                showSymbol: false,
                lineStyle: {type: 'dashed'},
                data: fit,
            });
        },
        buildDisplaySeries(series, bounds, outlierRange) {
            return series.map(s => ({
                ...s,
                data: (s.data || []).map(pt => {
                    const date = this.getPointDate(pt);
                    const rawValue = this.getPointRawValue(pt);
                    if (date === null || rawValue === null || rawValue === undefined) {
                        return pt;
                    }
                    if (!this.isOutlierValue(rawValue, outlierRange)) {
                        return pt;
                    }
                    const clippedValue = rawValue > bounds.max ? bounds.max : bounds.min;
                    return {
                        value: [date, clippedValue],
                        rawValue,
                        clippedValue,
                        outlier: true,
                    };
                }),
            }));
        },
        buildEchartsSeries(series) {
            const chartSeries = [];
            series.filter(s => s && s.name).forEach(s => {
                const outlierData = [];
                const data = (s.data || []).map(pt => {
                    if (pt && typeof pt === 'object' && pt.outlier) {
                        const date = this.getPointDate(pt);
                        const clippedValue = pt.clippedValue;
                        if (date === null || clippedValue === null || clippedValue === undefined) {
                            return null;
                        }
                        const point = [date, clippedValue];
                        outlierData.push(point);
                        return point;
                    }
                    const date = this.getPointDate(pt);
                    const value = this.getPointRawValue(pt);
                    return date === null ? null : [date, value];
                });
                chartSeries.push({...s, data});
            });
            return chartSeries;
        },
        buildValueGrid(x, series) {
            if (!this.showValues) {
                this.valueGrid = {columns: '50px 30px', rows: []};
                return;
            }
            const columns = ['50px'].concat(x.map(_ => 'minmax(64px, 1fr)')).concat(['30px']).join(' ');
            const rows = series.filter(s => s.name !== '趋势线').map(s => {
                const valueMap = {};
                const outlierMap = {};
                (s.data || []).forEach(d => {
                    const date = this.getPointDate(d);
                    if (date) {
                        valueMap[date] = this.getPointRawValue(d);
                        outlierMap[date] = !!(d && typeof d === 'object' && d.outlier);
                    }
                });
                return {
                    name: s.name,
                    values: x.map(date => {
                        const text = this.formatTooltipValue(valueMap[date]) || '-';
                        return {date, text, outlier: outlierMap[date]};
                    }),
                };
            });
            this.valueGrid = {columns, rows};
        },
        refreshChartSize() {
            if (!this.chart) {
                return;
            }
            this.$nextTick(_ => this.chart.resize());
        },
        draw(x, series) {
            if (this.metric.metric_type === 'percent' && this.metric.category.indexOf('retain') < 0) {
                series.forEach(s => {
                    s.data.forEach(d => {
                        d[1] = parseFloat((d[1] * 100).toFixed(2))
                    })
                });
            }
            const outlierRange = this.detectOutlierRange(series);
            this.buildTrendLine(series, outlierRange);
            const {ymin, ymax} = this.collectYRange(series, outlierRange);
            const bounds = this.computeYAxisBounds(ymin, ymax);
            this._yAxisMin = bounds.min;
            this._yAxisMax = bounds.max;
            this._yAxisSpan = bounds.max - bounds.min;
            const displaySeries = this.buildDisplaySeries(series, bounds, outlierRange);
            const chartSeries = this.buildEchartsSeries(displaySeries);
            this.hoverDates = x;
            this.hoverSeries = displaySeries;
            this.buildValueGrid(x, displaySeries);
            const chart = this.resetChart();
            if (!chart) return;
            const finalSeries = this.buildSeries(chartSeries);
            const option = {
                grid: {
                    top: this.component.groupings.length ? 40 : 20,
                    bottom: 30,
                    right: 30,
                    left: 50
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                xAxis: {
                    type: 'category',
                    data: x,
                    axisTick: {
                        alignWithLabel: true,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#7d7b7b',
                        }
                    }
                },
                legend: {
                    show: this.component.groupings.length > 0,
                },
                yAxis: {
                    type: 'value',
                    min: bounds.min,
                    max: bounds.max,
                    axisLabel: {
                        formatter: value => this.formatYAxisNumber(value)
                    }
                },
                series: finalSeries,
            };
            this.$nextTick(() => {
                if (this.chart) {
                    this.chart.setOption(option, true);
                    this.chart.resize();
                }
            });
        }
    },
    beforeUnmount() {
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },
    watch: {
        showValues() {
            this.buildValueGrid(this.hoverDates, this.hoverSeries);
            this.refreshChartSize();
        },
    }
}
</script>

<style scoped>
.chart-panel {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.chart-main {
    width: 100%;
    flex: 1;
    min-height: 0;
}

.value-grid {
    display: grid;
    flex: 0 0 auto;
    max-height: 96px;
    overflow: auto;
    border-top: 1px solid var(--el-border-color-lighter);
    margin-top: 6px;
    padding-top: 4px;
    font-size: 11px;
    line-height: 16px;
}

.value-grid-name,
.value-grid-cell,
.value-grid-right {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.value-grid-name {
    color: var(--el-text-color-secondary);
    padding-right: 6px;
}

.value-grid-cell {
    text-align: center;
}

.value-grid-right {
    width: 30px;
}

.value-grid-outlier {
    color: #f56c6c;
    font-weight: 600;
}

</style>
